import { useState, useEffect } from 'react'
import { PreMenuPage } from '@/pages/PreMenuPage'
import { MenuPage } from '@/pages/MenuPage'
import { CheckoutPage } from '@/pages/CheckoutPage'
import { OrderTrackingPage } from '@/pages/OrderTrackingPage'
import { ActiveOrderBanner } from '@/components/checkout'
import { useMenuData } from '@/hooks/useMenuData'
import { useFavicon } from '@/hooks/useFavicon'

function App() {
  const { restaurant } = useMenuData()
  useFavicon(restaurant?.logo_url)

  useEffect(() => {
    if (restaurant?.title) {
      document.title = restaurant.title
    }
  }, [restaurant?.title])

  const [route, setRoute] = useState<string>(window.location.pathname || '/')

  const navigate = (path: string) => {
    if (path === route) return
    window.history.pushState({}, '', path)
    setRoute(path)
  }

  useEffect(() => {
    const onPopState = () => setRoute(window.location.pathname || '/')
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  const isCheckout = route === '/checkout'
  const isTracking =
    route === '/tracking' ||
    route.startsWith('/tracking/') ||
    route.startsWith('/order/')

  const showBanner = !isCheckout && !isTracking

  const renderPage = () => {
    if (isCheckout) {
      return <CheckoutPage navigate={navigate} />
    }

    if (isTracking) {
      const orderId = route.startsWith('/order/') ? route.split('/order/')[1] : undefined
      const trackingCode = route.startsWith('/tracking/') && route !== '/tracking'
        ? route.split('/tracking/')[1]
        : undefined
      return <OrderTrackingPage navigate={navigate} orderId={orderId} trackingCode={trackingCode} />
    }

    if (route === '/menu') {
      return <MenuPage onNavigate={navigate} />
    }

    return <PreMenuPage onNavigate={navigate} />
  }

  return (
    <>
      {renderPage()}
      {showBanner && <ActiveOrderBanner onViewOrder={() => navigate('/tracking')} />}
    </>
  )
}

export default App
